module.exports = __webpack_public_path__ + "images/109_160.jpg";